// src/features/cart/cartService.js

import { readSheet, appendRow, updateSheet } from "../../services/googleSheetsService";
import { SHEET_KEYS } from "../../core/constants";

/**
 * Fetch all cart items for a specific user
 * @param {string} userId
 * @returns {Promise<Array>} Array of cart items
 */
export const fetchCart = async (userId) => {
  const allItems = await readSheet(SHEET_KEYS.CART, "Cart!A2:E");
  // Assuming columns: userId | productId | title | quantity | price
  return allItems.filter((row) => row[0] === userId).map((row) => ({
    userId: row[0],
    productId: row[1],
    title: row[2],
    quantity: parseInt(row[3], 10),
    price: parseFloat(row[4]),
  }));
};

/**
 * Add an item to the cart
 * @param {Object} cartItem { userId, productId, title, quantity, price }
 */
export const addToCart = async (cartItem) => {
  const row = [
    cartItem.userId,
    cartItem.productId,
    cartItem.title,
    cartItem.quantity,
    cartItem.price,
  ];
  return appendRow(SHEET_KEYS.CART, "Cart!A:E", row);
};

/**
 * Remove a cart item for a user
 * @param {string} userId
 * @param {string} productId
 */
export const removeFromCart = async (userId, productId) => {
  const cartItems = await readSheet(SHEET_KEYS.CART, "Cart!A2:E");
  const updatedItems = cartItems.filter(
    (row) => !(row[0] === userId && row[1] === productId)
  );

  // Update entire range
  return updateSheet(SHEET_KEYS.CART, "Cart!A2:E", updatedItems);
};

/**
 * Update quantity for a specific cart item
 * @param {string} userId
 * @param {string} productId
 * @param {number} quantity
 */
export const updateCartItem = async (userId, productId, quantity) => {
  const cartItems = await readSheet(SHEET_KEYS.CART, "Cart!A2:E");
  const updatedItems = cartItems.map((row) => {
    if (row[0] === userId && row[1] === productId) {
      return [row[0], row[1], row[2], quantity, row[4]]; // keep title and price
    }
    return row;
  });

  return updateSheet(SHEET_KEYS.CART, "Cart!A2:E", updatedItems);
};

/**
 * Clear cart for a specific user
 * @param {string} userId
 */
export const clearCart = async (userId) => {
  const cartItems = await readSheet(SHEET_KEYS.CART, "Cart!A2:E");
  const updatedItems = cartItems.filter((row) => row[0] !== userId);
  return updateSheet(SHEET_KEYS.CART, "Cart!A2:E", updatedItems);
};